import useLogisticParties from "./useLogisticParties";
export function useSelectedLp() {
    var logisticParties = useLogisticParties();
    return logisticParties === null || logisticParties === void 0 ? void 0 : logisticParties.lpSelected;
}
export default useSelectedLp;

//# sourceMappingURL=useSelectedLp.js.map